
import React, { useRef, useState, useCallback, useEffect, useMemo, useRef as useRefAlias, startTransition } from 'react';
import { Box, IconButton, Checkbox,Menu,MenuItem,Tabs,Tab } from '@mui/material';
import CustomText, { textStyles } from '../../../components/CustomText';
import SelectDropdown from "../../../components/SingleSelectDropdown"
import CustomButton from '../../../components/CustomButton';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import Webcam from "react-webcam";
import {Dialog, DialogContent,DialogTitle} from "@mui/material";
import '../../../App.css';
import back from "../../../assets/back.svg";
import deleteicon from "../../../assets/Settings/deleteicon.svg";
import ChangePasswordSettings from "./ChangePassword"
import DeleteSettingsModal from "./Delete";
import save from '../../../assets/save.svg';
import dummy from "../../../assets/dummy.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Slices/AuthSlice";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from '../../../components/BaseUrl';
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from 'react-redux';
import AddIcon from "@mui/icons-material/Add";

import document1 from "../../../assets/document1.svg";
import imageicon from "../../../assets/imageicon.png";
import CloseIcon from "@mui/icons-material/Close";

import {
  getCountriesByRegions,
  getCitiesByCountryNames,
} from "../../AuthPages/Registeration/helper";
import AttendanceSettingsView from './AttendanceSchedule';
import ProfileLocationMap from './MapSection';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const buildImageSrc = (raw, baseUrl, fallback) => {
  if (!raw) return fallback;
  if (raw.startsWith('data:')) return raw;
  if (raw.startsWith('http')) return raw;
  const prefix = raw.startsWith('/') ? '' : '/';
  return `${baseUrl}${prefix}${raw}`;
};

const AccountSetting = ({ onBack }) => {
  const { t } = useTranslation("");

  const [savingProfile, setSavingProfile] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false); // for mandatory region error
// inside AccountSetting component
  const [faceStatus, setFaceStatus] = useState(null);
  const [loadingFace, setLoadingFace] = useState(true);
  const [openWebcam, setOpenWebcam] = useState(false);
  const [faceImageUrl, setFaceImageUrl] = useState(null);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
const openProfileMenu = Boolean(profileMenuAnchor);
const [activeTab, setActiveTab] = useState(0);
const [passwordOpen, setPasswordOpen] = useState(false);
const [deleteOpen, setDeleteOpen] = useState(false);
const [deleteLoading, setDeleteLoading] = useState(false);
const dispatch = useDispatch();
const navigate = useNavigate();

const [showProfileCamera, setShowProfileCamera] = useState(false);
const [capturedProfile, setCapturedProfile] = useState(null);
const [takingProfilePhoto, setTakingProfilePhoto] = useState(false);
const user = useSelector((state) => state.auth.user); 
  const webcamRef = useRef(null);
const documentInputRef = useRef(null);
const [uploadingDocument, setUploadingDocument] = useState(false);
const [documentFileName, setDocumentFileName] = useState("");
const [documentType, setDocumentType] = useState(null); // "pdf" | "image"
const [documentUrl, setDocumentUrl] = useState("");

  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await fetch(`${BASE_URL}/workers/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      if (!res.ok || data.error) throw new Error(data.message || "Failed to load profile");

      const p = data.data.profile;

      // set profile image preview
      setPreviewUrl(buildDisplayUrl(p.profile_image));

      // populate form values

        formik.setValues({
          ...formik.values,
          firstName: p.first_name || "",
          middleName: p.middle_name || "",
          lastName: p.last_name || "",
          email: p.email || "",
          phone: p.phone || "",
          dob: p.dob ? p.dob.split("T")[0] : "",
          departmentId: p.department_id || "",
          designation: p.designation || "",
          employeeType: p.employee_type || "",
          hireDate: p.hire_date ? p.hire_date.split("T")[0] : "",
          community: p.community || "",
          province: p.province || "",
          city: p.city || "",
          country: p.country || "",
          postalCode: p.postal_code || "",
          streetAddress: p.street_address || "",
          shiftSchedule: p.shift_schedule || "",
          salary: p.salary || "",
          workHours: p.work_hours || "",
          latitude: p.latitude ? parseFloat(p.latitude) : null,
          longitude: p.longitude ? parseFloat(p.longitude) : null,
          assignRegion: p.assign_region || "",
          regions: p.assign_zone || "", // Preload as string
          primary_color: p.primary_color || "#e52a2a",
          secondary_color: p.secondary_color || "#42e06a",
        });
// ===== Prefill National ID document =====
if (p.document_url) {
  setDocumentUrl(p.document_url);

  const name = p.document_url.split("/").pop();
  setDocumentFileName(name);

  const ext = name.split(".").pop()?.toLowerCase();
  setDocumentType(ext === "pdf" ? "pdf" : "image");
}
        // Mark profile as loaded
        setProfileLoaded(true);
        
        // Set initial location for map
        if (p.latitude && p.longitude) {
          setInitialLocation({
            lat: parseFloat(p.latitude),
            lng: parseFloat(p.longitude)
          });
        }


    } catch (err) {
      toast.error(err.message || "Could not load profile");
    } finally {
      setInitLoading(false);
    }
  };

  fetchProfile();
}, []);

const handlePickDocument = () => {
  documentInputRef.current?.click();
};

const handleDocumentChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  // detect type
  const type = file.type.startsWith("image/")
    ? "image"
    : file.type === "application/pdf"
    ? "pdf"
    : null;

  if (!type) {
    toast.error("Please select a valid image or PDF file");
    documentInputRef.current.value = "";
    return;
  }

  try {
    setUploadingDocument(true);

    setDocumentFileName(file.name);
    setDocumentType(type);

    const form = new FormData();
    form.append(type, file);

    const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");

    const uploadedUrl = data?.data?.url || data?.url || data?.path || "";

    setDocumentUrl(uploadedUrl);
    toast.success(`${type.toUpperCase()} uploaded successfully`);
  } catch (err) {
    toast.error(err.message || "Upload failed");
    setDocumentUrl("");
    setDocumentFileName("");
    setDocumentType(null);
  } finally {
    setUploadingDocument(false);
    documentInputRef.current.value = "";
  }
};

  const formik = useFormik({
    initialValues: {
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      dob: "",
      departmentId: "",
      community: "",
      province: "",
      city: "",
      country: "Spain",
      postalCode: "",
      phone: "",
      regions: "", // assign_zone stored as string
      streetAddress: "",
      latitude: null,
      longitude: null,
      timezone: "",
      countryCode: "",
      region: "",
      continent: "",
      designation: "",
      employeeType: "",
      hireDate: "",
      shiftSchedule: "",
      salary: "",
      workHours: "",
      primary_color: "#e52a2a",
      secondary_color: "#42e06a",
    },
    onSubmit: async (values) => {
      try {
        setSubmitAttempted(true);

     

        setSavingProfile(true);

        const rawEncryptedToken = localStorage.getItem("token");
        const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

        const payload = {
          first_name: values.firstName,
          middle_name: values.middleName,
          last_name: values.lastName,
          email: values.email,
          phone: values.phone,
          dob: values.dob,
          profile_image: profileImageRaw || "",
          department_id: values.departmentId,
          designation: values.designation,
          employee_type: values.employeeType,
          hire_date: values.hireDate,
          latitude: values.latitude,
          longitude: values.longitude,
          assign_region: values.assignRegion,
          assign_zone: values.regions, // string
          country: values.country,
          community: values.community,
          province: values.province,
          city: values.city,
          postal_code: values.postalCode,
          street_address: values.streetAddress,
          shift_schedule: values.shiftSchedule,
          salary: values.salary,
          work_hours: values.workHours,
          primary_color: values.primary_color,
          secondary_color: values.secondary_color,
          document_url: documentUrl || "",
        };

console.log("🚀 Sending PUT /workers/profile");
console.log("📦 Payload:", payload);

const res = await fetch(`${BASE_URL}/workers/profile`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(payload),
});

// Log raw response before parsing
const rawText = await res.text();
console.log("📩 RAW RESPONSE:", rawText);

let data;
try {
  data = JSON.parse(rawText);
} catch (err) {
  console.error("❌ JSON parse error:", err);
  throw new Error("Server returned invalid JSON: " + rawText);
}

// Log parsed response
console.log("📌 PARSED RESPONSE:", data);

if (!res.ok || data.error) {
  console.error("❌ BACKEND ERROR:", data.message);
  throw new Error(data.message || "Update failed");
}

toast.success(t("updateSuccess"));

        window.dispatchEvent(new CustomEvent("profileUpdated", { detail: payload }));
      } catch (err) {
// toast.error(t("profile.genericError"));
      } finally {
        setSavingProfile(false);
      }
    }
  });

  // ---- Target Region/Zone/Cities ----

  // Regions (static)
  const [regionOptions, setRegionOptions] = useState([]);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    const ALL_REGIONS = [
      "North America",
      "South America",
      "Europe",
      "Asia",
      "Africa",
      "Oceania",
    ];
    setRegionOptions(ALL_REGIONS);
    setInitLoading(false);
  }, []);

  const toArray = (input) => {
    if (Array.isArray(input)) return input;
    if (input && input.target) return input.target.value ?? [];
    return [];
  };





  
  const [useBackendLocation, setUseBackendLocation] = useState(false);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [initialLocation, setInitialLocation] = useState(null);

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const handleMapLocation = useCallback((loc) => {
    // Only update if we're not using backend location (to avoid overriding backend data)
    if (!useBackendLocation) {
      formik.setFieldValue('streetAddress', loc.streetAddress || loc.address || '');
      formik.setFieldValue('city',         loc.city || '');
      formik.setFieldValue('province',     loc.province || '');
      formik.setFieldValue('community',    loc.community || '');
      formik.setFieldValue('postalCode',   loc.postalCode || '');
      formik.setFieldValue('country',      loc.country || '');
      formik.setFieldValue('latitude',     loc.latitude ?? null);
      formik.setFieldValue('longitude',    loc.longitude ?? null);
      formik.setFieldValue('timezone',     loc.timezone || '');
      formik.setFieldValue('countryCode',  loc.countryCode || '');
      formik.setFieldValue('region',       loc.region || '');
      formik.setFieldValue('continent',    loc.continent || '');
    }
  }, [useBackendLocation, formik]);

  const fileInputRef = useRef(null);
  const [profileImageRaw, setProfileImageRaw] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const buildDisplayUrl = (raw) => {
    if (!raw) return "";
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;
  };
  const extractUploadUrl = (data) =>
    data?.url ||
    data?.imageUrl ||
    data?.path ||
    data?.filePath ||
    data?.location ||
    data?.result?.url ||
    data?.result?.path ||
    data?.data?.url ||
    data?.data?.path ||
    data?.data?.location ||
    "";
const [imageUploading, setImageUploading] = useState(false);
  const handleImageSelect = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const localPreview = URL.createObjectURL(file);
    setPreviewUrl(localPreview);
  setImageUploading(true);  // 🔥 Start loader

    try {
      const formData = new FormData();
      formData.append("image", file);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();
      if (!res.ok || json?.error) throw new Error(json?.message || "Image upload failed");

      const raw = extractUploadUrl(json);
      setProfileImageRaw(raw);
      setPreviewUrl(buildDisplayUrl(raw));
      toast.success(t("imageUploaded"));

    } catch (err) {
      toast.error(err.message || "Upload failed");
    }
    finally {
    setImageUploading(false); // 🔥 Stop loader
  }
  };

  useEffect(() => {
    return () => {
      if (previewUrl?.startsWith("blob:")) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const imgSrc = (profileImageRaw && buildDisplayUrl(profileImageRaw)) || previewUrl || dummy;


  
  // ---- Fetch Face Status ----
  useEffect(() => {
    const fetchFaceStatus = async () => {
      try {
        const res = await fetch(`${BASE_URL}/attendance/face-status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        console.log("Fetched face status:", json);
        if (!res.ok || json.error) throw new Error(json.message);
        setFaceStatus(json.data);
      } catch (err) {
        toast.error(err.message || "Failed to fetch face status");
      } finally {
        setLoadingFace(false);
      }
    };
    fetchFaceStatus();
  }, [token]);

  // ---- Capture & Upload ----
  const captureAndUpload = async () => {
    console.log("👉 Capture button clicked");

    if (!webcamRef.current) {
      console.error("❌ webcamRef is null");
      alert("Webcam is not ready");
      return;
    }

    const imageSrc = webcamRef.current.getScreenshot();
    console.log("📸 Captured Image:", imageSrc ? "YES" : "NO");

    if (!imageSrc) {
      alert("No image captured. Try again.");
      return;
    }

    try {

      // Step 1: Upload image
      const formData = new FormData();
      formData.append("image", dataURItoBlob(imageSrc), "face.jpg");

      console.log("📤 Uploading to:", `${BASE_URL}/upload/image`);
      const uploadRes = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      console.log("✅ Upload response status:", uploadRes.status);
      const text = await uploadRes.text();
      console.log("📤 Upload response text:", text);

      let uploadJson;
      try {
        uploadJson = JSON.parse(text);
      } catch (e) {
        throw new Error("Upload did not return valid JSON: " + text);
      }

      console.log("✅ Upload JSON parsed:", uploadJson);

      if (!uploadRes.ok || uploadJson.error) {
        throw new Error(uploadJson.message || "Image upload failed");
      }

      const uploadedUrl = uploadJson?.data?.url;
      console.log("🌐 Uploaded URL:", uploadedUrl);

      if (!uploadedUrl) {
        alert("Upload failed: No URL returned");
        return;
      }


      // Step 2: Update face
      console.log("📡 Sending update-face request...");
      const res = await fetch(`${BASE_URL}/attendance/update-face`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ face_image_url: uploadedUrl }),
      });

      console.log("✅ Update-face status:", res.status);
      const updateText = await res.text();
      console.log("✅ Update-face raw response:", updateText);

      let updateJson;
      try {
        updateJson = JSON.parse(updateText);
      } catch (e) {
        throw new Error("Update-face did not return valid JSON: " + updateText);
      }

      // console.log("✅ Update-face JSON parsed:", updateJson);

      if (!res.ok || updateJson.error) throw new Error(updateJson.message);

      toast.success("🎉 Face updated successfully");
      setOpenWebcam(false);

      // Update UI with new face image
      setFaceImageUrl(uploadedUrl);
console.log("🖼️ Face Image Uploaded & Set Locally:", uploadedUrl);
      // Refresh status
      setLoadingFace(true);
      const statusRes = await fetch(`${BASE_URL}/attendance/face-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const statusJson = await statusRes.json();
      console.log("🔄 Refreshed face status:", statusJson);
      setFaceStatus(statusJson.data);
      setLoadingFace(false);
    } catch (err) {
      console.error("❌ Error in captureAndUpload:", err);
      alert("Error: " + err.message);
    }
  };

  // ---- Convert base64 to Blob ----
  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };



const editableFields = ["firstName", "middleName", "lastName", "phone"];

const isDisabled = (field) => !editableFields.includes(field);

  return (
    <>
      <Box sx={{ borderRadius: 2, px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minHeight: 55 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }} onClick={onBack}>
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}>
            {t("account_setting_screen.breadcrumb")}
          </CustomText>
        </Box>
      </Box>

<Box sx={{ background: "#fff", borderRadius: 2, p: 2, mb: 3 }}>
  <Tabs
 value={activeTab}
  onChange={(e, val) => {
    setActiveTab(val);

    if (val === 1) {
      setPasswordOpen(true); // 🔥 OPEN MODAL
    }
    if (val === 2) {
      setDeleteOpen(true); // 🔥 OPEN DELETE MODAL
    }
  }}
    indicatorColor="primary"
    textColor="primary"
      TabIndicatorProps={{
    sx: {
      height: 3,
      borderRadius: 2,
    },
  }}
    sx={{
    "& .MuiTab-root": {
      fontFamily: "Poppins, sans-serif", // 👈 font
      textTransform: "uppercase",        // 👈 uppercase
      fontSize: "13px",
      fontWeight: 500,
      letterSpacing: "0.06em",
      color: "#6B778C",
      minHeight: 44,
    },
    "& .Mui-selected": {
      color: "#0052CC",                  // active tab color
      fontWeight: 600,
    },
  }}
  >
    <Tab label={t("updateProfile")} />
    <Tab label={t("changePassword")} />
    <Tab label={t("tabs.deleteAccount")} />
  </Tabs>
</Box>
{/* {activeTab === 1 && <ChangePasswordSettings />} */}

      <Dialog open={openWebcam} onClose={() => setOpenWebcam(false)} maxWidth="sm" fullWidth 
        PaperProps={{
    sx: {
      borderRadius: "16px", // 🔥 more border radius
    },
  }}
        >
            <DialogTitle sx={{ m: 0, p: 2,mb:2 }}>
    <IconButton
      aria-label="close"
      onClick={() => setOpenWebcam(false)}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width="100%"
            videoConstraints={{ facingMode: "user" }}
          />
          <CustomButton
            label="Capture & Update"
            sx={{ mt: 2 }}
            onClick={captureAndUpload}
          />
        </DialogContent>
      </Dialog>


{activeTab === 0 && (

      <Box sx={{ width: '100%',  mx: 'auto', backgroundColor: 'white', px: 2, borderRadius: 2, py: 3 }}>
        <Toaster />
        <Box sx={{ display: "flex", gap: 3 }}>
            {/* LEFT SIDE — CURRENT PROFILE FORM */}
  <Box sx={{ width: "50%" }}>
        <form onSubmit={formik.handleSubmit}>
          <Box>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 600,
                fontSize: "17px",
                color: "#003149",
                fontFamily: "'Poppins', sans-serif",
                mb: 2,
              }}
            >
              {t("account_setting_screen.accountDetails")}
            </CustomText>
<Box sx={{
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  mb: 4
}}>
  
  <label className="field_label" style={{ marginBottom: 8 }}>
    {t("account_setting_screen.imageLabel")}
  </label>

<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mt: 1,
    mb: 2
  }}
>
  <Box sx={{ position: "relative", width: 120, height: 120 }}>

    {/*************** IF IMAGE EXISTS ***************/}
    {previewUrl || profileImageRaw ? (
      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          crossOrigin="anonymous"
          src={imgSrc}
          alt="profile"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover"
          }}
          onError={(e) => { e.currentTarget.src = dummy }}
        />

        {/* ⭐ TOP-RIGHT SMALL ADD (+) TO REPLACE IMAGE ⭐ */}
        <IconButton
          onClick={(e) => {
e.stopPropagation();
setProfileMenuAnchor(e.currentTarget);
}}
          sx={{
            position: "absolute",
            top: -6,
            right: -6,
            background: "rgba(0,0,0,0.5)",
            borderRadius: "50%",
            padding: "4px",
            "&:hover": {
  background: "rgba(0,0,0,0.6) !important", // same or darker
}
          }}
        >
          <AddIcon sx={{ color: "white", fontSize: 20 }} />
        </IconButton>
      </Box>
    ) : (
      /*************** IF NO IMAGE — SHOW DASHED CIRCLE ***************/
      <Box
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          border: "1px dashed #999",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          cursor: "pointer",
          position: "relative"
        }}
        onClick={() => !imageUploading && fileInputRef.current?.click()}
      >

        {/* Loader while uploading */}
        {imageUploading && (
          <CircularProgress size={32} sx={{ color: "#666", position: "absolute" }} />
        )}

        {/* Add icon only when not uploading */}
        {!imageUploading && (
          <AddIcon sx={{ fontSize: 28, color: "#666" }} />
        )}
      </Box>
    )}

    {/* Hidden input */}
    <input
      type="file"
      accept="image/*"
      ref={fileInputRef}
      style={{ display: "none" }}
      onChange={handleImageSelect}
    />
  </Box>
</Box>
<Menu
  anchorEl={profileMenuAnchor}
  open={openProfileMenu}
  onClose={() => setProfileMenuAnchor(null)}
>
  <MenuItem
    onClick={() => {
      setProfileMenuAnchor(null);
      setCapturedProfile(null);
      setShowProfileCamera(true);
    }}
    sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}
  >
    {t("takePhoto") || "Take Photo"}
  </MenuItem>

  <MenuItem
    onClick={() => {
      setProfileMenuAnchor(null);
      fileInputRef.current?.click();
    }}
    sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}
  >
    {t("chooseFromGallery") || "Choose from Gallery"}
  </MenuItem>
</Menu>

</Box>

            {/* Basic info */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("worker_settings.firstName")}</label>
                <input className="project_input" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} style={{ width: '100%', height: 40 }}
                  disabled={isDisabled("firstName")} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("worker_settings.middleName")}</label>
                <input className="project_input" name="middleName" value={formik.values.middleName} onChange={formik.handleChange} 
                  disabled={isDisabled("middleName")}
style={{ width: '100%', height: 40 }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("worker_settings.lastName")}</label>
                <input className="project_input" name="lastName" 
                  disabled={isDisabled("lastName")}
value={formik.values.lastName} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
            </Box>

            {/* Email */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("worker_settings.email")}</label>
                <input className="project_input" name="email"
                  disabled={isDisabled("email")}
 value={formik.values.email} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
            </Box>

            {/* Date of Birth */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("worker_settings.dob")}</label>
                <input type="date" className="project_input" name="dob" 
                  disabled={isDisabled("dob")}value={formik.values.dob} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
            </Box>

            {/* Phone */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1, mt: 0.8 }}>
                <label className="field_label" style={{ marginTop: "10px" }}>
                  {t("account_setting_screen.phoneLabel")} <span className="red_asterisk">*</span>
                </label>
                <Box
                  sx={{
                    border: "2px solid rgba(9,30,66,0.14)",
                    marginTop: "0px",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    "& .form-control": {
                      border: "none !important",
                      outline: "none !important",
                      boxShadow: "none !important",
                      width: "100%",
                      height: "36px",
                      fontSize: "14px",
                      paddingLeft: "48px",
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif !important",
                      backgroundColor: "transparent",
                    },
                    "& .flag-dropdown": {
                      border: "none !important",
                      borderRight: "1px solid #ccc !important",
                      backgroundColor: "#f9f9f9",
                      borderTopLeftRadius: "6px",
                      borderBottomLeftRadius: "6px",
                    },
                  }}
                >
                  <PhoneInput
  // <-- MAIN DISABLE
 countryCodeEditable={false}
                    country={"us"}
                    value={formik.values.phone}
                    onChange={(value) => formik.setFieldValue("phone", value)}
                    inputProps={{ name: "phone", required: true,  }}
                    containerClass="react-tel-input"
                    inputClass="form-control"
                                       

                    buttonClass="flag-dropdown"
                  />
                </Box>
              </Box>
            </Box>

     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,mt:2 }}>{/* Designation */}
<Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
  <label className="field_label">{t("worker_settings.designation")}</label>
  <input
    className="project_input"
    name="designation"
      disabled={isDisabled("designation")}

    value={formik.values.designation}
    onChange={formik.handleChange}
    style={{ width: '100%', height: 40 }}
  />
</Box>

{/* Employee Type */}
<Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
  <label className="field_label">{t("worker_settings.employeeType")}</label>
  <input
    className="project_input"
    name="employeeType"
      disabled={isDisabled("employeeType")}

    value={formik.values.employeeType}
    onChange={formik.handleChange}
    style={{ width: '100%', height: 40 }}
  />
</Box>
</Box>


{/* Hire Date + Shift Schedule */}
<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    <label className="field_label">{t("worker_settings.hireDate")}</label>
    <input
      type="date"
      className="project_input"
      name="hireDate"
      value={formik.values.hireDate}
      onChange={formik.handleChange}
        disabled={isDisabled("hireDate")}

      style={{ width: '100%', height: 40 }}
    />
  </Box>
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    <label className="field_label">{t("worker_settings.shiftSchedule")}</label>
    <input
      className="project_input"
      name="shiftSchedule"
      disabled={isDisabled("shiftSchedule")}
      value={formik.values.shiftSchedule}
      onChange={formik.handleChange}
      style={{ width: '100%', height: 40 }}
    />
  </Box>
</Box>

{/* Salary + Work Hours */}
<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    <label className="field_label">{t("worker_settings.salary")}</label>
    <input
      className="project_input"
      name="salary"
      disabled={isDisabled("salary")}
      value={formik.values.salary}
      onChange={formik.handleChange}
      style={{ width: '100%', height: 40 }}
    />
  </Box>

</Box>



<Box sx={{ mb: 2, mt: 3 }}>
  <label
    style={{
      color: "#626F86",
      fontSize: 14,
      marginBottom: 7,
      display: "inline-block",
    }}
  >
    {t("settings.nationalId")}
  </label>

  <Box
    sx={{
      position: "relative",
      border: "2px dashed #091E4224",
      borderRadius: "6px",
      padding: "20px",
      textAlign: "center",
      cursor: uploadingDocument ? "not-allowed" : "pointer",
      backgroundColor: "#f9f9f9",
      "&:hover": {
        backgroundColor: uploadingDocument ? "#f9f9f9" : "#f0f0f0",
      },
    }}
    onClick={() => !uploadingDocument && handlePickDocument()}
  >
    {uploadingDocument ? (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
        <CircularProgress size={20} />
        <span style={{ fontSize: 14 }}>{t("settings.uploading")}</span>
      </Box>
    ) : documentFileName ? (
      <Box sx={{ position: "relative", display: "inline-block" }}>
        <Box sx={{ mb: 0 }}>
          {documentType === "pdf" ? (
            <img src={document1} alt="PDF" width={30} />
          ) : (
            <img src={imageicon} alt="Image" width={30} />
          )}
        </Box>

        <span style={{ fontSize: 14, color: "#16a34a" }}>
          ✓ {documentFileName}
        </span>
        <br />
        <span style={{ fontSize: 12, color: "#666" }}>
          {t("settings.clickToChangeDocument")}
        </span>

        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setDocumentFileName("");
            setDocumentUrl("");
            setDocumentType(null);
          }}
          sx={{
            position: "absolute",
            top: -10,
            right: -10,
            backgroundColor: "white",
            boxShadow: "0 0 4px rgba(0,0,0,0.2)",
          }}
        >
          <CloseIcon sx={{ color: "red", fontSize: 18 }} />
        </IconButton>
      </Box>
    ) : (
      <Box>
        <span style={{ fontSize: 14, color: "#666" }}>
          {t("settings.dragFileHereOr")}{" "}
        </span>
        <span
          style={{
            fontSize: 14,
            color: "#006EC2",
            textDecoration: "underline",
          }}
        >
          {t("settings.clickToBrowse")}
        </span>
      </Box>
    )}
  </Box>

  <input
    ref={documentInputRef}
    type="file"
    accept="image/*,.pdf,application/pdf"
    hidden
    onChange={handleDocumentChange}
  />
</Box>




<Box sx={{mt:2, }}>
{initialLocation && (
   <ProfileLocationMap lat={initialLocation.lat} lng={initialLocation.lng} />
)}
</Box>
        
            <Box mt={3}>
              <CustomButton
                type="submit"
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {savingProfile && <CircularProgress size={16} sx={{ color: "#fff" }} />}
                    <img src={save} alt="save" width={16} height={16} />
                   {t("worker_settings.save")}
                  </Box>
                }
                size="medium"
              />
            </Box>
          </Box>
        </form>
         </Box>
          <Box
    sx={{
      width: "50%",
      background: "#fff",
      borderRadius: 2,
      padding: 2,
      height: "fit-content",
    }}
  >
    <CustomText
      sx={{
        ...textStyles.h1,
        fontWeight: 600,
        fontSize: "17px",
        color: "#003149",
        fontFamily: "'Poppins', sans-serif",
        mb: 2,
        px: 1,
      }}
    >
      {t("account_setting_screen.scheduleDetails")}
    </CustomText>
    <AttendanceSettingsView token={token} />
  </Box>
        </Box>
        {showProfileCamera && (
  <Dialog
    open={showProfileCamera}
    onClose={() => setShowProfileCamera(false)}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: 2 } }}
  >
    <DialogTitle>
      <IconButton
        onClick={() => setShowProfileCamera(false)}
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ textAlign: "center" }}>
      {!capturedProfile ? (
        <Webcam
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{ facingMode: "user" }}
          style={{ width: "100%", borderRadius: 8 }}
        />
      ) : (
        <img
          src={capturedProfile}
          alt="Captured"
          style={{ width: "100%", borderRadius: 8 }}
        />
      )}

      <Box sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 2 }}>
        {!capturedProfile ? (
          <CustomButton
            label={takingProfilePhoto ? t("uploading") : t("capture")}
            disabled={takingProfilePhoto}
            onClick={async () => {
              const img = webcamRef.current?.getScreenshot();
              if (!img) return;

              setTakingProfilePhoto(true);
              setCapturedProfile(img);

              const blob = await fetch(img).then((r) => r.blob());
              const file = new File([blob], "profile.jpg", {
                type: "image/jpeg",
              });

              // reuse existing gallery upload handler
              await handleImageSelect({
                target: { files: [file] },
              });

              setTakingProfilePhoto(false);
              setShowProfileCamera(false);
            }}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedProfile(null)}
          />
        )}

        <CustomButton
          label={t("close")}
          onClick={() => setShowProfileCamera(false)}
        />
      </Box>
    </DialogContent>
  </Dialog>
)}
      </Box>
      )}
      <ChangePasswordSettings
  open={passwordOpen}
  onClose={() => {
    setPasswordOpen(false);
    setActiveTab(0); // optional UX: go back to Update Profile
  }}
/>

<DeleteSettingsModal
  open={deleteOpen}
  loading={deleteLoading}
  onClose={() => {
    setDeleteOpen(false);
    setActiveTab(0);
  }}
  onConfirm={async (password) => {
    try {
      setDeleteLoading(true);
      const res = await fetch(`${BASE_URL}/workers/delete-account`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });
      const result = await res.json();

      if (!result.error) {
        toast.success(result.message || "Account deleted successfully");
        await dispatch(logout());
        navigate("/");
      } else {
        toast.error(result.message || "Delete failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setDeleteLoading(false);
      setDeleteOpen(false);
      setActiveTab(0);
    }
  }}
/>
    </>
  );
};

export default AccountSetting;





















